var BufferContextMenuView = require('buffercontextmenuview');


var ServerLogContextMenuView = BufferContextMenuView.extend({
    el: '#serverLogContextMenu',
    events: $.extend({}, BufferContextMenuView.prototype.events, {
        'buttonClick button.edit': 'clickEdit',
        'buttonClick button.join': 'clickJoin',
        'buttonClick button.delete': 'clickDelete',
        'buttonClick button.nickserv': 'clickNickserv',
        'buttonClick button.connToken__prompt': 'clickConnectionToken',
        'buttonClick button.disconnect': 'clickDisconnect',
        'buttonClick button.reconnect': 'clickReconnect',
        'buttonClick button.reorder': 'clickReorder',
        'buttonClick button.collapse': 'clickToggleCollapse',
        'buttonClick button.expand': 'clickToggleCollapse',
        'buttonClick button.discocollapse': 'clickDisconnectCollapse',
        'buttonClick button.deleteConversations': 'clickDeleteConversations',
        'buttonClick button.upgradeSlack': 'clickUpgradeSlack',
        'buttonClick button.replyCollapse': 'clickReplyCollapse',
        'buttonClick button.replyQuote': 'clickReplyQuote'
    }),
    clickEdit: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.select();
        this.buffer.connection.trigger('showEdit');
        this.clearContext();
    },
    clickJoin: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('joinPrompt');
        this.clearContext();
    },
    clickDelete: function (e) {
        e.preventDefault();
        if (!this.buffer.connection.isActive()) {
            this.hide();
            this.buffer.connection.trigger('deleteConfirm');
            this.clearContext();
        }
    },
    clickNickserv: function (e) {
        e.preventDefault();
        if (this.buffer.connection.isActive() && !this.buffer.connection.isOrgServer()) {
            this.hide();
            this.buffer.connection.trigger('nickServPrompt', this.buffer.connection);
            this.clearContext();
        }
    },
    clickConnectionToken: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('showConnectionToken', this.buffer.connection);
        this.clearContext();
    },
    clickDisconnect: function (e) {
        e.preventDefault();
        if (!this.buffer.connection.isInactive()) {
            this.hide();
            this.buffer.connection.disconnect();
            this.clearContext();
        }
    },
    clickReconnect: function (e) {
        e.preventDefault();
        if (this.buffer.connection.isInactive()) {
            this.hide();
            this.buffer.connection.reconnect();
            this.clearContext();
        }
    },
    clickReorder: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.session.trigger('reorderConnections', e);
        this.clearContext();
    },
    clickToggleCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.toggleCollapsed();
        this.clearContext();
    },
    clickDisconnectCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setCollapsingDisconnectsPref(!this.buffer.isCollapsingDisconnects());
        this.clearContext();
    },
    clickDeleteConversations: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.trigger('deletePMConfirm');
        this.clearContext();
    },
    clickUpgradeSlack: function (e) {
        e.preventDefault();
        this.buffer.connection.upgradeSlack();
    },
    clickReplyCollapse: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.setCollapsingRepliesPref(!this.buffer.connection.isCollapsingReplies());
        this.clearContext();
    },
    clickReplyQuote: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.setQuoteRepliesPref(!this.buffer.connection.isShowingQuoteReplies());
        this.clearContext();
    },
    onShow: function () {
        this.$('.contextMenu__buffer-actions').toggle(this.button.is('.bufferHead button'));

        this.deactivateItem(this.$('li.reorder'), !this.buffer.session.connections.length > 1, true);
        this.deactivateItem(this.$('li.collapse'), this.buffer.connection.isCollapsed(), true);
        this.deactivateItem(this.$('li.expand'), !this.buffer.connection.isCollapsed(), true);
        this.deactivateItem(this.$('li.reconnect'), !this.buffer.connection.isInactive(), true);
        this.deactivateItem(this.$('li.disconnect'), this.buffer.connection.isInactive(), true);
        this.deactivateItem(this.$('li.delete'), this.buffer.connection.isActive(), true);
        this.deactivateItem(this.$('li.nickserv'), this.buffer.connection.isOrgServer(), true);
        this.deactivateItem(this.$('li.connToken__menuitem'), !this.buffer.session.bncEnabled(), true);
        this.deactivateItem(this.$('li.nickserv'), !this.buffer.connection.isActive());
        this.deactivateItem(this.$('li.deleteConversations'), !this.buffer.connection.buffers.activeConversations.length, true);
        this.enableItem(this.$('li.collapseDisconnects'), this.buffer.isCollapsingDisconnects());
        this.deactivateItem(this.$('li.upgradeSlack'), !this.buffer.connection.isSlackUpgradable(), true);

        // Replies
        this.deactivateItem(this.$('li.replyCollapse'), !this.buffer.connection.hasReliableClientTags(), true);
        this.enableItem(this.$('li.replyCollapse'), this.buffer.connection.isCollapsingReplies());
    }
});


module.exports = ServerLogContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/serverlogcontextmenuview.js
// module id = JvxA
// module chunks = 1